module.exports = __webpack_public_path__ + "img/location-dot-slash.78763055.svg";